module.exports = __webpack_public_path__ + "media/images/front/pc/atopy-control-check-graph/bg_graph-abcc995ba90c299f736465715766995f.png";